export const overlaps = <T>(
  collection1: Set<T> | T[],
  collection2: Set<T> | T[],
): number => {
  let incidences = 0
  for (const element of collection1) {
    if (Array.from(collection2).includes(element)) incidences += 1
  }

  return incidences
}
